import {Role} from '../core/auth/user';

export class Activiteit {

  static deserialize(dto: ActiviteitDto): Activiteit {
    return new Activiteit(dto.id, dto.type, dto.update, dto.verwerkingsStatus, dto.clientId, dto.clientDiensten, dto.auteurId, dto.auteurRol, dto.auteurNummer, dto.content, new Date(dto.timestamp), dto.clientZone);
  }

  constructor(
    private id: string,
    private type: ActiviteitType,
    private update: boolean,
    private verwerkingsStatus: VerwerkingsStatus,
    private clientId: string,
    private clientDiensten: string[],
    // TODO remove clientdiensten from activiteit
    // TODO bekijk commit db0794d4 grondig om te zien wat er nog opgekuist moet worden
    private auteurId: string,
    private auteurRol: Role,
    private auteurNummer: string,
    private content: string,
    private timestamp: Date,
    private clientZone?: string,
  ) {
  }

  getId(): string {
    return this.id;
  }

  hasId(id: string): boolean {
    return this.getId() === id;
  }

  getType(): ActiviteitType {
    return this.type;
  }

  isUpdate(): boolean {
    return this.update;
  }

  getVerwerkingsStatus(): VerwerkingsStatus {
    return this.verwerkingsStatus;
  }

  isVerwerkt(): boolean {
    return this.verwerkingsStatus === VerwerkingsStatus.VERWERKT;
  }

  getClientId(): string {
    return this.clientId;
  }

  getClientDiensten(): string[] {
    return this.clientDiensten;
  }

  getAuteurId(): string {
    return this.auteurId;
  }

  getAuteurRol(): Role {
    return this.auteurRol;
  }

  getAuteurNummer(): string {
    return this.auteurNummer;
  }

  getContent(): string {
    return this.content;
  }

  getTimestamp(): Date {
    return this.timestamp;
  }

  getClientZone(): string | undefined {
    return this.clientZone;
  }
}

export enum ActiviteitType {
  CLIENT_MELDING = 'Client melding',
  SIGNAALKAART = 'Signaalkaart',
}

export enum VerwerkingsStatus {
  VERWERKT = 'Verwerkt',
  OPEN = 'Open',
}

export interface ActiviteitDto {
  id: string;
  type: ActiviteitType;
  update: boolean;
  verwerkingsStatus: VerwerkingsStatus;
  clientId: string;
  clientZone: string;
  clientDiensten: Array<string>;
  auteurId: string;
  auteurRol: Role;
  auteurNummer: string;
  content: string;
  timestamp: string;
}
